import * as path from 'node:path';
import { cliSimpleGit } from '../../cli-simple-git.js';
import { getRemoteOriginUrl } from '../../remote-origin-url.js';
import { yieldToEventLoop } from '../../git-runtime.js';
import { formatRemoteDisplayLabel } from '../paths/repo-format.js';

export async function loadWorkingTreeChangeRepoGitInfo(
  checkoutPath: string,
): Promise<{
  branch: string;
  remoteUrl: string;
  remoteDisplay: string;
}> {
  const resolvedCheckoutPath = path.resolve(checkoutPath);
  const git = cliSimpleGit(resolvedCheckoutPath);

  await yieldToEventLoop();
  const [branch, remoteUrl] = await Promise.all([
    git
      .raw(['rev-parse', '--abbrev-ref', 'HEAD'])
      .then((out) => out.trim() || 'HEAD')
      .catch(() => 'HEAD'),
    getRemoteOriginUrl(resolvedCheckoutPath),
  ]);

  return {
    branch,
    remoteUrl,
    remoteDisplay: formatRemoteDisplayLabel(remoteUrl),
  };
}
